import { createFileRoute, Link } from "@tanstack/react-router"
import { AuthForm } from "@/components/auth-form"
import { Logo } from "@/components/logo"

export const Route = createFileRoute("/jobs_/join")({
  validateSearch: (search: Record<string, unknown>): { returnTo?: string } => ({
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
  }),
  component: JobsJoinPage,
})

function JobsJoinPage() {
  const { returnTo } = Route.useSearch()
  return (
    <div className="mkt-auth home-wf">
      <Link to="/" className="home-wf-brand" aria-label="Hire home">
        <Logo />
      </Link>
      <div className="mkt-auth-card">
        <AuthForm mode="signup" lockedRole="seeker" returnTo={returnTo} />
      </div>
    </div>
  )
}
